<template>
  <div class="bankDtlcontent">
    <span class="closeCstmpop" @click="closeCustompop()">
      <i class="material-icons">close</i>
    </span>
    <h2>{{$t('modeToReturnPayment')}}</h2>
    <select v-model="bankDetailsDTO.paymentMode" class="selectTypepay">
      <option v-for="op in paymentModeList" :value="op">{{op}}</option>
    </select>

    <div class="viewPortcnt">
      <div class="payBackstatusbox" v-if="bankDetailsDTO.paymentMode=='PAYTM'">
        <h3>Paytm Detail</h3>
        <input
          type="number"
          v-model="bankDetailsDTO.phone"
          class="inputtextbg"
          placeholder="Enter Paytm Mobile Number"
        />
        <span class="paySubmit" @click="addBankDetails">Submit</span>
      </div>
      <div class="payBackstatusbox" v-if="bankDetailsDTO.paymentMode=='BANK'">
        <h3>Bank Detail</h3>
        <input
          type="text"
          v-model="bankDetailsDTO.accountHolderName"
          class="inputtextbg"
          placeholder="Account holder name"
        />
        <input
          type="text"
          v-model="bankDetailsDTO.accountNumber"
          class="inputtextbg"
          placeholder="Account Number"
        />
        <input
          type="text"
          v-model="bankDetailsDTO.ifc"
          class="inputtextbg"
          placeholder="Bank IFSC Code"
        />
        <input
          type="text"
          v-model="bankDetailsDTO.branchName"
          class="inputtextbg"
          placeholder="Branch name"
        />
        <input
          type="text"
          v-model="bankDetailsDTO.bankName"
          class="inputtextbg"
          placeholder="Bank name"
        />
        <span class="paySubmit" @click="addBankDetails">Submit</span>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import constant from "../../utils/constant";
import { bus } from "../../main";
export default {
  name: "AddBankDetails",
  data() {
    return {
      paymentModeList: ["PAYTM", "BANK"],
      bankDetailsDTO: {
        paymentMode: "PAYTM"
      },
      loading: false
    };
  },
  props:{
    returnId: String
  },
  methods: {
    closeCustompop() {
      document.querySelector("body").classList.remove("bankDetailbody");
    },
    addBankDetails() {
      this.loading = true;
      this.$store
        .dispatch({
          type: "postOrderReturnUrl",
          payload: this.returnId,
          postValue: this.bankDetailsDTO
        })
        .then(data => {
          this.loading = false;
          this.closeCustompop();
        })
        .catch(err => {
          this.loading = false;
          let obj = {
            status: "Failure",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        });
    }
  },
  mounted() {}
};
</script>
